/**
  ---DO NOT EDIT THIS FILE DIRECTLY---
  This CSS file was concatenated from files listed in the css/ folder as part of a build process
  This is to allow for js import with @import links which will not be followed
**/

/* src/primitives/modal/css/definition/content/modal.css */
@layer modal.definition.content.modal {
  dialog {
    position: fixed;
    width: inherit;
    outline: none;
    border: none;
    background-color: transparent;
    overflow: visible;
  }
  dialog {
    display: none;
    flex-direction: column;
    opacity: 0;
    scale: 0.8;
    transition: var(--modal-dialog-transition);
  }
  dialog[open] {
    display: flex;
    opacity: 1;
    scale: 1;
  }
  @starting-style {
    dialog[open] {
      opacity: 0;
      scale: 0.8;
    }
  }
  dialog::backdrop {
    background-color: rgb(0 0 0 / 0%);
    transition: var(--modal-dimmer-transition);
  }
  dialog[open]::backdrop {
    background: var(--modal-dimmer-background);
  }
  @starting-style {
    dialog[open]::backdrop {
      background: rgb(0 0 0 / 0%);
    }
  }
  dialog .modal {
    background: var(--modal-background);
    max-width: var(--modal-max-width);
    border-radius: var(--modal-border-radius);
    box-shadow: 0px 0px 0px rgba(0, 0, 0, 0);
    transition: var(--modal-transition);
  }
  dialog[open] .modal {
    box-shadow: var(--modal-box-shadow);
  }
  @starting-style {
    dialog[open] .modal {
      box-shadow: 0px 0px 0px rgba(0, 0, 0, 0);
    }
  }
  dialog ::slotted(.content) {
    padding: var(--padding);
  }
  dialog .close {
    cursor: pointer;
    align-self: flex-end;
    color: #FFF;
    margin: 0;
    font-size: 22px;
    padding: 1rem;
    opacity: 0.6;
    transition: var(--transition);
  }
  dialog .close:hover {
    opacity: 1;
  }
  dialog .close + .modal {
    margin-right: 3rem;
  }
}

/* src/primitives/modal/css/definition/types/glass.css */
@layer modal.definition.types.glass {
  .glass.modal {
    -webkit-backdrop-filter: var(--modal-glass-backdrop-filter);
    backdrop-filter: var(--modal-glass-backdrop-filter);
    box-shadow: var(--modal-glass-box-shadow);
    background: var(--modal-glass-background);
  }
}

/* src/primitives/modal/css/definition/variations/aligned.css */
@layer modal.definition.variations.aligned;

/* src/primitives/modal/css/definition/variations/sizing.css */
@layer modal.definition.variations.sizing {
  :host {
    width: var(--modal-medium);
  }
  :host([size="mini"]),
  :host([mini]),
  :host.mini {
    width: var(--modal-mini);
  }
  :host([size="tiny"]),
  :host([tiny]),
  :host.tiny {
    width: var(--modal-tiny);
  }
  :host([size="small"]),
  :host([small]),
  :host.small {
    width: var(--modal-small);
  }
  :host([size="large"]),
  :host([large]),
  :host.large {
    width: var(--modal-large);
  }
  :host([size="big"]),
  :host([big]),
  :host.big {
    width: var(--modal-big);
  }
  :host([size="huge"]),
  :host([huge]),
  :host.huge {
    width: var(--modal-huge);
  }
  :host([size="massive"]),
  :host([massive]),
  :host.massive {
    width: var(--modal-massive);
  }
}

/* src/primitives/modal/css/definition/modal-definition.css */

/* src/primitives/modal/css/theme/content/modal-variables.css */
@layer modal.theme.content.modal {
  :host {
    --modal-box-shadow: 2px 5px 15px rgba(0, 0, 0, 0.3);
    --modal-border-radius: var(--border-radius);
    --modal-background: var(--white);
    --modal-dimmer-background: var(--black-50);
    --modal-max-width: calc(100vw - 2rem);
    --modal-transition: all 300ms ease 100ms;
    --modal-dialog-transition-duration: 200ms;
    --modal-dialog-transition:
      opacity var(--modal-dialog-transition-duration) ease,
      scale var(--modal-dialog-transition-duration) ease,
      overlay var(--modal-dialog-transition-duration) ease allow-discrete,
      display var(--modal-dialog-transition-duration) ease allow-discrete;
    --modal-dimmer-transition-duration: 700ms;
    --modal-dimmer-transition:
      display var(--modal-dimmer-transition-duration) allow-discrete,
      overlay var(--modal-dimmer-transition-duration) allow-discrete,
      background var(--modal-dimmer-transition-duration);
  }
}

/* src/primitives/modal/css/theme/types/glass-variables.css */
@layer modal.theme.types.glass {
  :host {
    --modal-glass-background: none transparent;
    --modal-glass-blur: 7px;
    --modal-glass-backdrop-filter: blur(var(--modal-glass-blur));
    --modal-glass-box-shadow:
      inset -0.75px -0.5px rgba(255, 255, 255, 0.1),
      inset +0.75px +0.5px rgba(255, 255, 255, 0.025),
      3px 2px 10px rgba(0, 0, 0, 0.25),
      inset 0px 0px 10px 5px rgba(255, 255, 255, 0.025),
      inset 0px 0px 40px 5px rgba(255, 255, 255, 0.025) ;
  }
}

/* src/primitives/modal/css/theme/variations/aligned-variables.css */
@layer modal.theme.variations.aligned {
  :host {
  }
}

/* src/primitives/modal/css/theme/variations/sizing-variables.css */
@layer modal.theme.variations.sizing {
  :host {
    --modal-mini: 320px;
    --modal-tiny: 400px;
    --modal-small: 500px;
    --modal-medium: 700px;
    --modal-large: 850px;
    --modal-big: 1100px;
    --modal-huge: 1300px;
    --modal-massive: 1600px;
  }
}

/* src/primitives/modal/css/theme/modal-theme.css */

/* src/primitives/modal/css/modal.css */
